import { NgModule } from "@angular/core";
import { HeadingComponent } from "../../components/heading/heading.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { RadioComponent } from "../../components/form-elements/radio/radio.component";
import { CheckboxComponent } from "../../components/form-elements/checkbox/checkbox.component";
import { FormBaseElement } from "../../components/form-elements/form-base-element";
import { ControlErrorComponent } from "../../components/form-elements/control-error/control-error.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TextInputComponent } from "../../components/form-elements/text-input/text-input.component";
import { DisablesForTimeDirective } from "./directives/disables-for-time.directive";
import { FormErrorMsgDirective } from "./directives/form-error-msg.directive";
import { SimpleCounterComponent } from "../../components/form-elements/simple-counter/simple-counter.component";
import { FoldableTextInputComponent } from "../../components/form-elements/foldable-text-input/foldable-text-input.component";
import { AuctionInfoBoxComponent } from "../../components/auction-parts/auction-info-box/auction-info-box.component";
import { CountdownComponent } from "../../components/auction-parts/countdown/countdown.component";
import { CountDownPipe } from "./pipes/countdown.pipe";
import { PriceFormatterPipe } from "./pipes/priceFormatter.pipe";
import { HeaderComponent } from "../../components/header/header.component";
import { FooterComponent } from "../../components/footer/footer.component";
import { CustomFoldableComponent } from "../../components/form-elements/custom-foldable/custom-foldable.component";
import { TermsAndConditionsComponent } from "../../components/terms-and-conditions/terms-and-conditions.component";
import { TermsAndConditionsPopupComponent } from "../../components/terms-and-conditions-popup/terms-and-conditions-popup.component";
import { TestComponent } from "../../test/test.component";
import { FillBalanceComponent } from "../../components/balance/fill-balance/fill-balance.component";
import { WithdrawBalanceComponent } from "../../components/balance/withdraw-balance/withdraw-balance.component";
import { inputFocusBlur } from "../../modules/shared/directives/input-hostlistener.directive";
import { AuctionImagesPopupComponent } from "../../components/auction-images-popup/auction-images-popup.component";
import { LoaderComponent } from "src/app/components/loader/loader.component";
import { PaginationComponent } from "src/app/components/pagination/pagination.component";
import { PaymentResultComponent } from "src/app/components/payment/paymentResult.component";
import { OutbiddedMessageComponent } from "src/app/components/auction-parts/outbidded-message/outbidded-message.component";
import { TNetCompanies } from "../../components/t-net-companies/t-net-companies.component";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
  declarations: [
    HeadingComponent,
    FormBaseElement,
    RadioComponent,
    CheckboxComponent,
    TextInputComponent,
    DisablesForTimeDirective,
    inputFocusBlur,
    FormErrorMsgDirective,
    ControlErrorComponent,
    SimpleCounterComponent,
    FoldableTextInputComponent,
    AuctionInfoBoxComponent,
    CountdownComponent,
    CountDownPipe,
    PriceFormatterPipe,
    HeaderComponent,
    FooterComponent,
    CustomFoldableComponent,
    TermsAndConditionsComponent,
    TermsAndConditionsPopupComponent,
    TestComponent,
    FillBalanceComponent,
    AuctionImagesPopupComponent,
    WithdrawBalanceComponent,
    LoaderComponent,
    PaginationComponent,
    PaymentResultComponent,
    OutbiddedMessageComponent,
    TNetCompanies,
  ],
  entryComponents: [
    ControlErrorComponent,
    TestComponent,
    FillBalanceComponent,
    OutbiddedMessageComponent,
    WithdrawBalanceComponent,
    TermsAndConditionsPopupComponent,
    LoaderComponent,
    PaginationComponent,
  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    CommonModule,
    DragDropModule,
  ],
  exports: [
    RouterModule,
    HeadingComponent,
    RadioComponent,
    CheckboxComponent,
    TextInputComponent,
    DisablesForTimeDirective,
    FormErrorMsgDirective,
    ControlErrorComponent,
    SimpleCounterComponent,
    FoldableTextInputComponent,
    AuctionInfoBoxComponent,
    CountdownComponent,
    CountDownPipe,
    PriceFormatterPipe,
    HeaderComponent,
    FooterComponent,
    CustomFoldableComponent,
    TermsAndConditionsComponent,
    TermsAndConditionsPopupComponent,
    TestComponent,
    FillBalanceComponent,
    OutbiddedMessageComponent,
    AuctionImagesPopupComponent,
    WithdrawBalanceComponent,
    LoaderComponent,
    PaginationComponent,
    DragDropModule,
    TNetCompanies,
  ],
})
export class SharedModule {}
